import React from 'react';
import {SortableElement} from 'react-sortable-hoc';
import PropTypes from "prop-types";

const SortableCoursesItem = SortableElement(({value, number, index, handleChangeVisible, removeAssignedTest}) => {

    if (value.chapterTitle) {
        return (
            <li
                key={number+"_"+index}
                className="ui-sortable-handle sort-item"
            >
                {value.chapterTitle} {value.number}
                <button
                    className={`btn btn-default zmdi col-grey ${value.visible ? 'zmdi-eye' : 'zmdi-eye-off hover-danger btn-danger'}`}
                    onClick={()=> handleChangeVisible(value.id)}
                >
                </button>
            </li>
        )
    } else {
        return (
            <li
                key={number+"_"+index}
                className="ui-sortable-handle sort-item"
            >
                {value.testTitle} {value.description}
                <button
                    className="btn btn-default hover-danger zmdi zmdi-delete col-grey"
                    onClick={() => removeAssignedTest(value.id)}
                >
                </button>
            </li>
        )
    }

});

SortableCoursesItem.propTypes = {
    value: PropTypes.object.isRequired,
    number: PropTypes.number,
    index: PropTypes.number,
    handleChangeVisible: PropTypes.func,
    removeAssignedTest: PropTypes.func
};

export default SortableCoursesItem;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableCoursesItem.js